import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

import Configuration from "../../foundation/Configuration";
import { MenuItem } from "../../types/system/MenuItem";

export interface CustomConfigSection {
    name: string;
    items: MenuItem[];
}

// Define the type for our state store entry
type MenuState = {
    selected: MenuItem;
};

// Define the initial state for our state store entry
const initialState: MenuState = {
    selected: null,
};

// Create a slice to hold all our reducers
const menuSlice = createSlice({
    name: "menu",
    initialState: initialState,
    reducers: {
        setSelectedMenuItem: (state, action: PayloadAction<MenuItem>) => {
            state.selected = action.payload;
            document.title = state.selected?.name ?? Configuration.friendlyName;
        },
    },
    extraReducers(builder) {
        builder.addCase(REHYDRATE, (_, rawData: any) => {
            if (rawData?.key !== "tts") return undefined;
            return initialState;
        });
    },
});

export const { setSelectedMenuItem } = menuSlice.actions;

// We have to export the reducer as this is added to the state store
export default menuSlice.reducer;
